"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCodeChallenge = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const use_persisted_state_1 = __importDefault(require("use-persisted-state"));
const useCodeVerifierState = use_persisted_state_1.default('oauth-code-verifier');
function useCodeChallenge() {
    const [codeVerifier, setCodeVerifier] = useCodeVerifierState(null);
    const { data: codeChallenge } = react_query_1.useQuery([codeVerifier], () => createCodeChallenge(codeVerifier), { enabled: !!codeVerifier });
    react_1.useEffect(() => {
        if (!codeVerifier) {
            setCodeVerifier(generateCodeVerifier());
        }
    }, [codeVerifier, setCodeVerifier]);
    const reset = react_1.useCallback(() => {
        setCodeVerifier(generateCodeVerifier());
    }, [setCodeVerifier]);
    return react_1.useMemo(() => ({ codeVerifier, codeChallenge, reset }), [
        codeChallenge,
        reset,
        codeVerifier,
    ]);
}
exports.useCodeChallenge = useCodeChallenge;
function generateCodeVerifier() {
    var array = new Uint32Array(32);
    window.crypto.getRandomValues(array);
    return toBase64UrlEncoded(array);
}
function toBase64UrlEncoded(a) {
    return btoa(String.fromCharCode(...new Uint8Array(a)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}
function createCodeChallenge(codeVerifier) {
    return __awaiter(this, void 0, void 0, function* () {
        const verifierBytes = new TextEncoder().encode(codeVerifier);
        const digest = yield window.crypto.subtle.digest('SHA-256', verifierBytes);
        return toBase64UrlEncoded(digest);
    });
}
//# sourceMappingURL=useCodeChallenge.js.map